const ISDEV = false
const APPID_RELEASE = '48hkp980v6l'
const APPID_DEV = '18on3lbvfik0'
const LUBAN_TYPE = 2 // luban账号类型， 手管token验证还是 同步key验证
const MOCK = false
const PLATFORMTYPE_QQPIM_ANDOIRD = 5
const PLATFORMTYPE_QQPIM_IOS = 6

const DEV_VIP = 1 // 测试开关，0忽略，1会员，2非会员

// 平台  enum EPlatformType
// {
//   EPT_UNKNOWN             = 0,      // 未知
//     EPT_ANDROID             = 1,      // 手管Android
//     EPT_IPHONE              = 2,      // 手管iPhone
//     EPT_WXAPPLET            = 3,      // 手管接听助理小程序
//     EPT_WXMMGRMP            = 4,      // 手管微信服务号
//     EPT_SYNC_ANDROID        = 5,      // 同步助手Android
//     EPT_SYNC_IPHONE         = 6,      // 同步助手iPhone
// };

module.exports = {
  ISDEV,
  APPID_RELEASE,
  APPID_DEV,
  LUBAN_TYPE,
  MOCK,
  DEV_VIP,
  PLATFORMTYPE_QQPIM_ANDOIRD,
  PLATFORMTYPE_QQPIM_IOS
}



// WEBPACK FOOTER //
// ./src/env.js